import { RequestWithRelations } from '@/models/request';
import { UserFromGetSession } from '@/models/user';
import { WorkflowPublic } from '@/models/workflow';
import {
  ArticleWithRelationsInStep,
  RequestArticleContextData,
  RequestContextData,
} from '@/routes/Requests/contexts/interfaces';

import { computeServiceChoiceOptions } from '../utils/compute-service-choice-options';

export const computeCreationContext = ({
  article,
  view,
  requestView,
}: {
  request: RequestWithRelations;
  requestView: RequestContextData['view'];
  workflow?: WorkflowPublic;
  article: ArticleWithRelationsInStep<'creation'>;
  view: RequestArticleContextData['view'];
  currentSession: UserFromGetSession;
}) => {
  view.initialCondition.editable = true;
  view.warranty.editable = true;

  view.defects.canAddRemoveDefect = true;
  view.defects.fields.description.editable = true;
  view.defects.fields.photo.editable = true;
  view.defects.fields.context.editable = true;
  view.defects.fields.toBeRepaired.editable = true;
  view.defects.fields.brandResponsibility.toggle.editable = true;
  view.defects.fields.brandResponsibility.exceptionalCoverage.toggle.editable = true;

  /**
   * SERVICES
   */
  view.services.choice.shown = !!article.step.config.requireServiceChoice;
  view.services.choice.editable = true;
  view.services.choice.serviceOptions = computeServiceChoiceOptions(article, view, 'creation');

  view.services.actions.canAddAction = true;
  view.services.actions.canRemoveAction = true;
  view.services.actions.fields.description.editable = true;
  view.services.actions.fields.context.editable = true;
  view.services.actions.fields.photo.editable = true;
  view.services.actions.fields.associatedDefects.editable = true;
  view.services.actions.fields.additionalInfo.editable = true;
  view.services.actions.fields.brandResponsibility.editable = true;
  view.services.actions.fields.organizationPrice.editable = requestView.organizationPrice.editable;
  view.services.actions.fields.organizationPrice.required = !!article.step.config.requirePrice;
  view.services.actions.fields.spareParts.canAddRemoveSparePart = true;
  view.services.actions.fields.spareParts.referenceNumber.editable = true;
  view.services.actions.fields.spareParts.quantity.editable = true;
  view.services.actions.fields.spareParts.organizationPrice.editable =
    requestView.organizationPrice.editable;
  view.services.actions.fields.spareParts.organizationPrice.required =
    !!article.step.config.requirePrice;

  view.services.dispatch.shown =
    article.snapshot.serviceChoice === 'care-repair' && !!article.step.config.requireDispatch;
  view.services.dispatch.editable = true;

  view.services.exchange.exchangeType.editable = true;
  view.services.exchange.replacementProduct.editable = true;
  view.services.exchange.stockLocation.editable = true;
  view.services.exchange.organizationPrice.editable = requestView.organizationPrice.editable;
  view.services.exchange.organizationPrice.required = true;

  view.services.exchangeArchival.shown = false;
  view.services.refund.shown = false;
  view.services.none.shown = false;

  /**
   * THRESHOLDS
   */
  view.prices.thresholds.organization.shown =
    view.prices.thresholds.organization.shown && view.services.dispatch.shown;
  view.prices.thresholds.client.editable = true;
  view.prices.thresholds.organization.editable = true;
};
